jQuery(document).ready(function ($) {
    'use strict';

    var HH = window.HH || {};

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined'
        || typeof HH.revelerEnLignes !== 'function') {
        return;
    }

    /* Moins de mouvement demande : aucun etat de depart n'est pose, donc
       le bloc reste tel que le navigateur l'a rendu. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_sourcing');

    if (!blocs.length) {
        return;
    }

    /**
     * CHRONOLOGIE
     * Positions de depart sur la timeline et durees, en secondes.
     * DECLENCHEMENT suit la syntaxe ScrollTrigger : le haut du bloc
     * atteignant 80 % de la hauteur de la fenetre.
     */
    var DEPART_TRIANGLE = 0;
    var DEPART_ACCROCHE = 0.2;

    var DUREE_TRIANGLE = 0.9;
    var LIGNES = {duree: 0.7, decalage: 0.09};

    /* L'image enchaine sur l'accroche, dont la duree depend du nombre de
       lignes decoupees : sa position est donc relative et non absolue.
       '>' est la fin du tween precedent, '-0.2' un chevauchement pour que
       l'enchainement ne marque pas un temps d'arret. */
    var POSITION_IMAGE = '>-0.2';
    var DUREE_IMAGE = 0.8;
    var DISTANCE_IMAGE = 60;

    var DECLENCHEMENT = 'top 80%';

    Array.prototype.forEach.call(blocs, function (bloc) {
        /* sourcing.scss masque le triangle sous small-screen : la largeur
           mesuree vaut alors zero et il n'y a rien a animer. */
        var triangle = bloc.querySelector('.triangle');

        if (triangle && triangle.getBoundingClientRect().width <= 0) {
            triangle = null;
        }

        var accroche = bloc.querySelector('.accroche');
        var image = bloc.querySelector('.first_content figure');

        if (!triangle && !accroche && !image) {
            return;
        }

        /* Etats de depart poses tout de suite, sans attendre les polices :
           le bloc peut deja etre a l'ecran au chargement. Le clip-path du
           triangle place son angle droit en haut a gauche, la ou il est
           ancre : il se deplie donc depuis sa propre pointe. */
        if (triangle) {
            gsap.set(triangle, {scale: 0, transformOrigin: 'top left'});
        }

        if (accroche) {
            gsap.set(accroche, {opacity: 0});
        }

        if (image) {
            gsap.set(image, {y: DISTANCE_IMAGE});
        }

        HH.policesPretes().then(function () {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: bloc,
                    start: DECLENCHEMENT,
                    once: true
                }
            });

            if (triangle) {
                tl.to(triangle, {
                    scale: 1,
                    duration: DUREE_TRIANGLE
                }, DEPART_TRIANGLE);
            }

            HH.revelerEnLignes(tl, accroche, DEPART_ACCROCHE, LIGNES);

            if (image) {
                tl.to(image, {
                    y: 0,
                    duration: DUREE_IMAGE
                }, POSITION_IMAGE);
            }
        });
    });
});
